import { Box, Typography, Grid } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[900],
        color: 'white',
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/background_weave.jpg)`,
        backgroundRepeat: 'repeat',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)', // Reduced opacity to make background image more visible
          zIndex: 0,
        },
      }}
    >
      <Grid container spacing={2} alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Left side - Accreditation */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: '80%' }}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/assets/images/cognia_badge.png`}
              alt="COGNIA Accreditation Badge"
              sx={{ height: 100, width: 'auto' }}
            />
            <Typography variant="body2">
              We Are Accredited By COGNIA,<br />NCA CASI, NWAC, and SACS CASI
            </Typography>
          </Box>
        </Grid>

        {/* Center - Maryland Certification */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: '90%' }}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/assets/images/maryland-cert-seal.png`}
              alt="Maryland Certification Seal"
              sx={{ height: 100, width: 'auto' }}
            />
            <Typography variant="body2">
              A Nonpublic School Approved By The Maryland State Board Of Education
            </Typography>
          </Box>
        </Grid>

        {/* Right side - Logo and Copyright */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/assets/images/MacGillis Global Academy-05.png`}
            alt="MGA Logo"
            sx={{ height: 60, width: 'auto', mb: 1 }}
          />
          <Typography variant="body2">
            © 2025 by macgillisglobalacademy.net
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer; 